import {Component, Input} from '@angular/core';
import {BookingStatus} from '../../enums/booking-status.enum';

@Component({
  selector: 'app-booking-status',
  templateUrl: './booking-status.component.html'
})
export class BookingStatusComponent {

  @Input() status!: string;

  // Normalize status to display string
  get label(): string {
    return this.status;
  }

  // Determine icon class based on label
  get icon(): string {
    const s = this.label;
    switch (s) {
      case 'Completed':
        return 'pi-check-circle';

      case 'Pending':
      case 'In Progress':
        return 'pi-clock';

      case 'Cancelled':
      case 'CancelledBySitter':
      case 'PAYMENT_ERROR':
        return 'pi-times-circle';

      case 'Created':
      case 'Confirmed':
        return 'pi-info-circle';

      case 'Scheduled':
        return 'pi-calendar';

      default:
        return 'pi-question-circle';
    }
  }

  // Determine text color class based on label
  get cssClass(): string {
    const s = this.label;
    switch (s) {
      case 'Completed':
        return 'text-success';

      case 'Pending':
      case 'In Progress':
        return 'text-warning';

      case 'Cancelled':
      case 'CancelledBySitter':
      case 'PAYMENT_ERROR':
        return 'text-danger';

      case 'Created':
      case 'Confirmed':
        return 'text-info';

      case 'Scheduled':
        return 'text-primary';

      default:
        return 'text-muted';
    }
  }
}
